import { Doughnut } from "react-chartjs-2";
import { registerCharts } from "./register-chart";

registerCharts();

export interface DonutChartSegment {
    label: string;
    value: number;
    color: string;
}

export interface DonutChartProps {
    segments: DonutChartSegment[];
    /** Accessible label for the chart canvas. */
    ariaLabel: string;
    className?: string;
}

/**
 * Reusable donut chart driven entirely by segment props.
 * Legend rendering is left to the parent so layouts can vary by page.
 */
export function DonutChart({ segments, ariaLabel, className }: DonutChartProps) {
    const data = {
        labels: segments.map((segment) => segment.label),
        datasets: [
            {
                data: segments.map((segment) => segment.value),
                backgroundColor: segments.map((segment) => segment.color),
                borderWidth: 0,
                hoverOffset: 2,
            },
        ],
    };

    return (
        <div className={className} role="img" aria-label={ariaLabel}>
            <Doughnut
                data={data}
                options={{
                    responsive: true,
                    maintainAspectRatio: true,
                    cutout: "68%",
                    plugins: {
                        legend: { display: false },
                        tooltip: {
                            callbacks: {
                                label: (context) => {
                                    const label = context.label ?? "";
                                    const value = typeof context.parsed === "number" ? context.parsed : 0;
                                    return `${label}: ${value.toLocaleString()}`;
                                },
                            },
                        },
                    },
                }}
            />
        </div>
    );
}
